import { render } from "./PanelTipsterConversionCampana.vue?vue&type=template&id=dd0c24c8&scoped=true"
import script from "./PanelTipsterConversionCampana.vue?vue&type=script&lang=js"
export * from "./PanelTipsterConversionCampana.vue?vue&type=script&lang=js"

import "./PanelTipsterConversionCampana.vue?vue&type=style&index=0&id=dd0c24c8&scoped=true&lang=css"

import exportComponent from "/var/www/html/quanty/quanty-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd0c24c8"]])

export default __exports__